import React from 'react'

import { Trans, useTranslation } from 'react-i18next'

import Button from '@components/shared/Button'
import Dialog from '@components/shared/Dialog'
import ExternalLink from '@components/shared/ExternalLink'
import { useDialogStore } from '@stores/dialog.store'
import { useSession } from '@stores/globalData/globalData.store'

const AccessSoundCheckAndContentDialog: React.FC = () => {
  const { t } = useTranslation()
  const session = useSession()

  const title = session.isDefaultCommunity()
    ? t('content.accessSoundCheckAndPremium')
    : t('content.accessSoundCheckAndContent')
  return (
    <Dialog name="access_sc_and_content" maxWidth={400} title={title}>
      <DialogBody />
    </Dialog>
  )
}

const DialogBody: React.FC = () => {
  const { t } = useTranslation()
  const closeDialog = useDialogStore((s) => s.closeDialog)
  const session = useSession()

  // Admin
  if (session.isSiteAdmin()) {
    return (
      <>
        <p className="mb-3">{t('content.addSoundCheckAndContentDesc')}</p>
        <Button
          variant="primary"
          className="text-md px-2 py-1.5 float-right mt-2"
          onClick={() => {
            window.open('https://www.noteflight.com/commerce/purchase_learn', '_blank')
            closeDialog('access_sc_and_content')
          }}>
          {t('action.purchaseAddOns')}
        </Button>
      </>
    )
  }

  // Teacher
  if (session.isSiteTeacher()) {
    return (
      <>
        <p className="mb-3">{t('content.addSoundCheckAndContentDesc')}</p>
        <p className="mb-3">
          <Trans i18nKey="content.addSoundCheckAndContentDesc_teacher">
            Talk to your site’s admin to add SoundCheck and Premium Content. If your site has
            SoundCheck and Premium Content, manage access in Manage Site &gt;
            <a
              title="addons"
              className="orange-link"
              href={`/groups#/group/${session.communityGroup?.id}/addons`}>
              Manage Add-Ons
            </a>
          </Trans>
        </p>
      </>
    )
  }

  // Student
  if (session.isSiteStudent()) {
    return (
      <p className="mb-3">{t('content.addSoundCheckAndContentDesc', { context: 'student' })}</p>
    )
  }

  // Default community
  if (session.isDefaultCommunity()) {
    return (
      <>
        <p className="mb-3">
          <span className="block">{t('content.addSoundCheckDesc')}</span>
          <ExternalLink
            title="learn more"
            href="/soundcheck"
            className="text-orange hover:underline">
            {t('action.learnMore')}
          </ExternalLink>
        </p>
        <Button
          variant="primary"
          className="text-md px-2 py-1.5 float-right mt-2"
          onClick={() => {
            window.open('/commerce/purchase_annual?sc=true', '_blank')
            closeDialog('access_sc_and_content')
          }}>
          {t('action.purchasePremiumWithSC')}
        </Button>
      </>
    )
  }

  return null
}

export default AccessSoundCheckAndContentDialog
